import { FC } from 'react';

import cx from 'classnames';
import { Arrow, ToggleLayer } from 'react-laag';

import Dropdown from 'components/shared/Dropdown';
import Icon from 'components/shared/Icon';
import Close from 'components/shared/Icon/icons/Close';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';

import styles from '../../../../Modal/index.module.css';
import { useTourTooltip } from './functions';
import s from './index.module.css';
import { ToolTipStep, ToolTipSwitch } from './Step';
import { ITourTooltipProps } from './types';

const TourTooltip: FC<ITourTooltipProps> = ({ children, steps, cards, notifications = [] }) => {
  const { activeStep, showPopup, buttonHandler, handleToggleShowPopup, setActiveStep } = useTourTooltip({
    steps,
    notifications,
  });
  const { isTabletOrMobile } = useMediaBreakpoints();

  return (
    <ToggleLayer
      fixed
      isOpen={showPopup}
      renderLayer={({ isOpen, layerProps, arrowStyle, layerSide }) =>
        isOpen && (
          <div className={cx(s.fade)}>
            <div
              ref={layerProps.ref}
              className="layer"
              style={{
                ...layerProps.style,
                left: isTabletOrMobile ? '50%' : layerProps.style.left,
                zIndex: 9999,
                transform: isTabletOrMobile && 'translate(-50%)',
              }}
            >
              <Dropdown className="custom-right-header-dropdown">
                <ToolTipSwitch>
                  {cards.map(({ title, bodyText, buttonText }, idx) => (
                    <ToolTipStep
                      key={idx}
                      id={idx + 1}
                      title={title}
                      bodyText={bodyText}
                      buttonText={buttonText}
                      activeStep={activeStep}
                      stepsCount={steps}
                      onDotClick={setActiveStep}
                      onClick={buttonHandler}
                    />
                  ))}
                </ToolTipSwitch>
                <CloseButton onClick={handleToggleShowPopup} isDesktop={!isTabletOrMobile} />
              </Dropdown>
              {!isTabletOrMobile && (
                <Arrow
                  style={{ ...arrowStyle, zIndex: '22' }}
                  layerSide={layerSide}
                  borderWidth={1}
                  borderColor="rgba(0, 0, 0, 0.04)"
                  backgroundColor="#fff"
                  angle={50}
                  roundness={0.5}
                  size={6}
                />
              )}
            </div>
          </div>
        )
      }
      placement={{
        anchor: 'BOTTOM_CENTER',
        autoAdjust: true,
        triggerOffset: 10,
      }}
    >
      {({ triggerRef }) => (
        <>
          <div className={s.iconWrapper} ref={triggerRef} onClick={() => handleToggleShowPopup(false)}>
            {children}
          </div>
        </>
      )}
    </ToggleLayer>
  );
};

export default TourTooltip;

const CloseButton = ({ onClick, isDesktop }: { onClick: () => void; isDesktop: boolean }) => {
  const sideSize = isDesktop ? '2rem' : '2.5rem';
  return (
    <button
      type="button"
      className={cx(styles.modalClose, s.tooltipModalClose, 'custom-modal-close-btn')}
      tabIndex={0}
      onClick={onClick}
    >
      <Icon
        component={Close}
        className={cx(styles.closeIcon, 'custom-modal-close-icon')}
        fill="#3E3E40"
        width={sideSize}
        height={sideSize}
      />
    </button>
  );
};
